import { useMemo } from "react"
import { useLandscapeDisplayInfo } from "@hg/layouts"

export const useScale = (fontSize: number) => {
    const { width, height } = useLandscapeDisplayInfo()

    const scale = useMemo(() => {
        const designRatio = 16 / 9
        const currentRatio = width / height

        if (currentRatio > designRatio) {
            return width / ((1920 / 16) * fontSize)
        } else {
            return height / ((1080 / 16) * fontSize)
        }
    }, [width, height, fontSize])

    return scale
}
